module.exports = __webpack_public_path__ + "static/media/mmsys_118.5408dfab.ico";